// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__6PUUo","notification":"styles_notification__97nPs"};